{
    "TermsAndConditions_Title": "Algemene voorwaarden",
    "TermsAndConditions_Subtitle": "De gebruiksvoorwaarden van de applicatie vindt u hieronder. Geef aan dat u deze accepteert door \"Ik ga akkoord met de servicevoorwaarden\" aan te vinken en op de knop \"Accepteren\" te klikken.",
    "TermsAndConditions_Subtitle_NoAccept": "Onze standaard servicevoorwaarden vindt u hieronder.",
    "TermsAndConditions_AcceptText": "Ik ga akkoord met de algemene voorwaarden",
    "TermsAndConditions_AcceptButton": "Accepteren",
    "TermsAndConditions_CloseButton": "Afsluiten",
    "NAME": "TermsAndConditions"
}